(function() {
    'use strict';

    angular.module('app.reportes', []);
})();
